module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 194
// module chunks = 0